import React from 'react';

import {
  ArtistArtworkStyled,
  ArtistContainer,
  MetricItem,
  MetricsContainer,
  MetricUnit,
  MetricValue
} from '../../styles/ArtistMetrics.styled';

type ArtistMetricsProps = {
  artistName: string;
  monthlyListener: string;
  totalStreams: string;
  socialFollowers: string;
  artistArtworkLink: string;
};

export const ArtistMetrics = ({
  artistName,
  monthlyListener,
  totalStreams,
  socialFollowers,
  artistArtworkLink
}: ArtistMetricsProps) => {
  return (
    <>
      <ArtistContainer>
        <ArtistArtworkStyled src={artistArtworkLink} />
        RMZ
      </ArtistContainer>
      <MetricsContainer>
        <MetricItem>
          <MetricValue>{monthlyListener}+</MetricValue>
          <MetricUnit>Monthly Listeners</MetricUnit>
        </MetricItem>
        <MetricItem>
          <MetricValue>{totalStreams}+</MetricValue>
          <MetricUnit>Total Streams</MetricUnit>
        </MetricItem>
        <MetricItem>
          <MetricValue>{socialFollowers}+</MetricValue>
          <MetricUnit>Social Followers</MetricUnit>
        </MetricItem>
      </MetricsContainer>
    </>
  );
};
